<div class="nav-bar">
  <div class="left-part">
    <button
      mat-mini-fab
      id="nav-left-button"
      (click)="emitToggleSidebarEvent()"
    >
      <i class="material-icons" style="font-size: 18px">more_vert</i>
    </button>
    <h4>{{ title }}</h4>
  </div>
  <div class="right-part">
    <div class="right-part" id="nav-right">
      <button
        class="icon-btn"
        (click)="showDashboard()"
        mat-icon-button
        aria-label="Go to dashboard"
      >
        <i class="material-icons">dashboard</i>
      </button>
      <app-msgiconbtn
        icon="notifications"
        number="5"
        [matMenuTriggerFor]="menu"
      ></app-msgiconbtn>
      <button mat-icon-button [matMenuTriggerFor]="user">
        <mat-icon>person</mat-icon>
      </button>
      <mat-menu #menu="matMenu"> </mat-menu>
      <mat-menu #user="matMenu">
        <button mat-menu-item (click)="showProfile()">Profile</button>
        <button mat-menu-item (click)="updatePassword()">
          Update Password
        </button>
        <button mat-menu-item (click)="signout()">Logout</button>
      </mat-menu>
    </div>
    <div id="menu">
      <button mat-icon-button><i class="material-icons">menu</i></button>
    </div>
  </div>
</div>
